var SIGN_UP_NAMESPACE = 'sign-up';
var SET_SIGN_UP_DATA = 'SET_SIGN_UP_DATA';
var SET_SIGN_UP_FORM = 'SET_SIGN_UP_FORM';
var RESET_FORM_MODEL = 'RESET_FORM_MODEL';
var RESET = 'RESET';

export { RESET, RESET_FORM_MODEL, SET_SIGN_UP_DATA, SET_SIGN_UP_FORM, SIGN_UP_NAMESPACE };
